
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Elevation, Scheme } from "@ronuse/norseu/core/variables";
import { Toast } from "@ronuse/norseu/core/overlay";

export class PanelPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
        this.toast = React.createRef();
		this.onExpand = this.onExpand.bind(this);
		this.onCollapse = this.onCollapse.bind(this);
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Panel>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vulputate dolor neque, 
                                vel porta sem tincidunt ut. Pellentesque lacinia orci quis sagittis tincidunt. 
                                Proin viverra varius orci, at blandit mauris feugiat vitae. Aliquam elit nisi, 
                                molestie ac maximus eget, aliquet nec tortor. Pellentesque bibendum ante vel risus efficitur volutpat.</p>
                            </Panel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">With Elevation</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Panel elevation={Elevation.ONE}>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vulputate dolor neque, 
                                vel porta sem tincidunt ut. Pellentesque lacinia orci quis sagittis tincidunt. 
                                Proin viverra varius orci, at blandit mauris feugiat vitae. Aliquam elit nisi, 
                                molestie ac maximus eget, aliquet nec tortor. Pellentesque bibendum ante vel risus efficitur volutpat.</p>
                            </Panel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Title And Collapsible</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Panel title="Title">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vulputate dolor neque, 
                                vel porta sem tincidunt ut. Pellentesque lacinia orci quis sagittis tincidunt. 
                                Proin viverra varius orci, at blandit mauris feugiat vitae. Aliquam elit nisi, 
                                molestie ac maximus eget, aliquet nec tortor. Pellentesque bibendum ante vel risus efficitur volutpat.</p>
                            </Panel>
                            <br/>
                            <Panel title="Title" collapsible expanded>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vulputate dolor neque, 
                                vel porta sem tincidunt ut. Pellentesque lacinia orci quis sagittis tincidunt. 
                                Proin viverra varius orci, at blandit mauris feugiat vitae. Aliquam elit nisi, 
                                molestie ac maximus eget, aliquet nec tortor. Pellentesque bibendum ante vel risus efficitur volutpat.</p>
                            </Panel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Skeleton Panel</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p">
                                When the type of panel is set to skeleton rather than applying the skeleton effect 
                                to the main panel the type is relayed down to the child components for application
                            </p>
                            <Panel scheme={Scheme.SKELETON}>
                                <Panel>
                                    <p>When the type of panel is set to skeleton rather than applying the skeleton effect 
                                        to the main panel the type is relayed down to the child components for application.
                                    </p>
                                </Panel>
                                <br/>

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vulputate dolor neque, 
                                vel porta sem tincidunt ut. Pellentesque lacinia orci quis sagittis tincidunt. 
                                Proin viverra varius orci, at blandit mauris feugiat vitae. Aliquam elit nisi, 
                                molestie ac maximus eget, aliquet nec tortor. Pellentesque bibendum ante vel risus efficitur volutpat.
                                <br/>

                                <Button text="Hello World" scheme={Scheme.PRIMARY}/>

                                <Button icon="fa fa-check" scheme={Scheme.PRIMARY} rounded/>
                                <Button icon="fa fa-check" scheme={Scheme.PRIMARY} rounded/>
                                <Button icon="fa fa-check" scheme={Scheme.PRIMARY} rounded/>
                                <Button icon="fa fa-check" scheme={Scheme.PRIMARY} rounded/>
                                <Button icon="fa fa-check" scheme={Scheme.PRIMARY} rounded/>
                                <Button icon="fa fa-check" scheme={Scheme.PRIMARY} rounded/>

                                <br/><br/>
                                <div>
                                    Hello World
                                    <br/><br/>
                                    <Button icon="fa fa-check"/>
                                    <div>
                                        This is inner div but better still this should also be skeletoned
                                        <br/><br/><br/>
                                        <p>This is inner div but better still this should also be skeletoned</p>
                                        <br/><br/>
                                        <Button text="we good" icon="fa fa-check"/>
                                    </div>
                                </div>
                                
                            </Panel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Events</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Panel title="onCollapse, onExpand Events" onExpand={this.onExpand} onCollapse={this.onCollapse} collapsible expanded>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vulputate dolor neque, 
                                vel porta sem tincidunt ut. Pellentesque lacinia orci quis sagittis tincidunt. 
                                Proin viverra varius orci, at blandit mauris feugiat vitae. Aliquam elit nisi, 
                                molestie ac maximus eget, aliquet nec tortor. Pellentesque bibendum ante vel risus efficitur volutpat.</p>
                            </Panel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
                <Toast scheme={Scheme.SECONDARY} ref={this.toast}/>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "Panel",
            import_statement: "import { Panel } from '@ronuse/norseu/core/panels'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/panels/PanelPage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "text", type: "string", default: "", description: "The label to show in the button" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
    ]

    onCollapse() {
        this.toast.current.show([{ title: "Panel Events", description: "The Panel has been collapsed" }]);
    }

    onExpand(event) {
        this.toast.current.show([{ title: "Panel Events", description: "The Panel has been expanded" }]);
    }

}
